import { AppState } from '@/vuex/store';
import CustomerRemark from '@/customer/models/CustomerRemark';

export default {
  CANCEL_MERGING_REMARK_ITEM: (state: AppState, remarkId: number) => {
    const remarks = state.customerState.mergingRemarks;
    for (let key = 0; key < remarks.length; key ++) {
      if (remarks[key].id === remarkId) {
        remarks.splice(key, 1);
      }
    }
  },
  SELECT_MERGING_REMARK_ITEM: (state: AppState, remark: CustomerRemark) => {
    const remarks = state.customerState.mergingRemarks;
    if (!remarks.some((r: CustomerRemark) => {
      return r.id === remark .id;
    })) {
      remarks.push(remark);
    }
  },
  CANCEL_MERGE_REMARKS: (state: AppState) => {
    state.customerState.mergingRemarks = [];
  },
};
